import { render, staticRenderFns } from "./edit.vue?vue&type=template&id=0221f0bd&scoped=true&"
import script from "./edit.vue?vue&type=script&lang=ts&"
export * from "./edit.vue?vue&type=script&lang=ts&"
import style0 from "./edit.vue?vue&type=style&index=0&id=0221f0bd&lang=less&scoped=true&"
import style1 from "./edit.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0221f0bd",
  null
  
)

export default component.exports